import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="file-upload"
export default class extends Controller {
  static targets = ["fileInput", "fileName"];

  selectFile() {
    if (this.fileInputTarget.files.length > 0) {
      this.element.requestSubmit();
    } else {
      console.log("No file selected.");
    }
  }

  chooseFile() {
    this.fileInputTarget.click();
  }

  updateFileName() {
    if (!this.hasFileNameTarget) return;

    const file = this.fileInputTarget.files[0];
    if (!file) return;

    const maxBytes = 200 * 1024 * 1024;
    if (file.size > maxBytes) {
      this.fileInputTarget.value = "";
      this.fileNameTarget.textContent = this.fileInputTarget.dataset.sizeError || "";
      return;
    }

    this.fileNameTarget.textContent = file.name;
  }
}
